import dynamic from "next/dynamic";
import { STLoader } from "@/components";
import MainLayout from "@/Layout/MainLayout";
import "@/styles/globals.css";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const STSmoothScroll = dynamic(
  () => import("@/components/STSmoothScroll").then((mod) => mod.STSmoothScroll),
  { ssr: false },
);
import Script from "next/script";

export default function App({ Component, pageProps }) {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const isBlogDetailPage = router.pathname === "/news-feed/[slug]";

  useEffect(() => {
    const handleStart = (url) => {
      if (url !== router.asPath) {
        setLoading(true);
      }
    };

    const handleStop = () => {
      setLoading(false);
    };

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleStop);
    router.events.on("routeChangeError", handleStop);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleStop);
      router.events.off("routeChangeError", handleStop);
    };
  }, [router.events, router.asPath]);

  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=G-YR437ZWY2Q`}
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
      >
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-YR437ZWY2Q', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
      {loading && <STLoader />}
      {!isBlogDetailPage && <STSmoothScroll />}
      <MainLayout>
        <Component {...pageProps} />
      </MainLayout>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
